import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectEntitiesByFilters } from "../../../../../store/views/entityView";
import { oldCoursesFilters } from "../../../../../utils/entitiesFiltersUtils";
import Widget from "../../../../features/widget/Widget";
import MyLearningDomainHeader from "../myLearningDomainHeader/MyLearningDomainHeader";
import MyCourseItem from "../../../../features/courseItem/myCourseItem/MyCourseItem";
import iconsList from "../../../../ui/icons/iconsList";
import Page from "../../../../ui/page/Page";
import pathRouts from "../../../../../enums/pathRoute";
import SectionList from "../SectionList/SectionList";
import Text from "../../../../features/text/Text";
import classes from "./MyLearningArchivePage.module.css";

const MyLearningArchivePage = () => {

    const { texts } = useSelector(state => state.translate);
    const navigate = useNavigate();
    const archiveDomain = useSelector(state => state?.uiData?.general?.archiveDomain)
    const oldCourses = useSelector(state => selectEntitiesByFilters(state, oldCoursesFilters));

    return (
        <Page
            title={archiveDomain?.text || texts.myLearning}
            onBack={() => navigate(`/${pathRouts.MYLEARNING}`)}
            className={classes.MyLearningDomainPage}
        >
            <div className={classes.MyLearningDomainPage}>
                <MyLearningDomainHeader domain={archiveDomain} />
                <div className={classes.Content}>
                    <div className={classes.DesktopContent}>
                        <Widget
                            icon={iconsList.myLearning}
                            color="#FDDB71"
                            title={texts.myLearningSubject}
                            height={525}
                            width={525}
                            className={classes.CoursessWidget}
                        >
                            <div className={classes.WidgetContent}>
                                <SectionList
                                    titel={texts.environments}
                                    classNameList={classes.CoursesList}
                                    ItemComponent={MyCourseItem}
                                    list={oldCourses}
                                    itemPropName="course"
                                    textForEmptyList={texts.noEnvironmentsAvailable}
                                />
                            </div>
                        </Widget>
                    </div>
                    <div className={classes.MobileContent}>
                        <div className={classes.CoursesListMobile}>
                            {oldCourses?.length > 0 ? (
                                oldCourses.map((course, index) => (
                                    <div key={course.id || course.externalId || index} className={classes.CourseItemWrapper}>
                                        <MyCourseItem course={course} />
                                    </div>
                                ))
                            ) : (
                                texts.noEnvironmentsAvailable && (
                                    <Text className={classes.EmptyState}>{texts.noEnvironmentsAvailable}</Text>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}
export default MyLearningArchivePage
